// extracted by mini-css-extract-plugin
export default {"screen-titles--title":"Text_screen-titles--title__mDDIM","text-title":"Text_text-title__zooDj","text-field":"Text_text-field__8r0yb"};